'use client';

import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';

import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import ChevronIcon from '@/fo/icons/base/icons/chevron16.svg';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './Wards.styles';

const CDN = staticMediaUrl('landing/bioderma_galchonok');

const tabs = [
  {
    id: 1,
    name: 'Кира',
    image: `${CDN}/avatar-kira.png`,
    photo: `${CDN}/kira.jpg`,
    fullName: 'Кира Русских',
    age: '4 года',
    diagnosis: 'ДЦП, атонически-астатическая форма',
    helpText:
      'Проект «Под крылом», долгосрочная социальная абилитация оплата реабилитационных услуг (долгосрочная социальная абилитация) в&nbsp;партнёрском&nbsp;центре&nbsp;фонда. Кира научилась ходить с ходунками, много ходит у&nbsp;опоры или за руки (раньше совсем отказывалась, когда пришли в центр она могла только стоять у опоры), физически стала крепче, например, сама может сесть на обычный стул, забраться на диван и также спуститься на пол. Больше понимает, улавливает эмоции собеседника, стала замечать дома кошку и ползает за ней (раньше совсем не видела). Если с самого начала за 10 мин любых занятий она уставала, то сейчас занимается намного лучше, стала усидчивее, но это точно благодаря подходу и настойчивости всех специалистов',
    quoteText:
      '«Занимаемся в центре около года, есть хорошие результаты в физической реабилитации, и в ментальном развитии. Для нас каждое занятие — это необходимая мера для улучшения жизни. Сейчас ходим на физкультуру, эрготерапию, к логопеду и АВА-терапию. Я очень благодарна возможности развивать и улучшать жизнь моего ребенка!»'
  },
  {
    id: 2,
    name: 'Владислав',
    image: `${CDN}/avatar-vladislav.png`,
    photo: `${CDN}/vladislav.jpg`,
    fullName: 'Владислав Сабинин',
    age: '13 лет',
    diagnosis: 'ДЦП, левосторонний спастический гемипарез',
    helpText:
      'Проект «Шаг вперед», оплата генетических исследований. Оплата генетического исследования методом диагностического секвенирования экзома.',
    quoteText:
      '«Хочу выразить огромную благодарность фонду «ГАЛЧОНОК» за участие в&nbsp;проекте генетических исследований. В нашей семье несколько детей имеют неврологические отклонения в развитии и нам очень важно было понять их&nbsp;происхождение. Сотрудники фонда всегда были на связи и&nbsp;информировали нас о всех изменениях в программе исследования. Всегда помогали и содействовали во всех вопросах! Спасибо за Вашу помощь!»'
  },
  {
    id: 3,
    name: 'Лев',
    image: `${CDN}/avatar-lev.png`,
    photo: `${CDN}/lev.jpg`,
    fullName: 'Лев Блохин',
    age: '15 лет',
    diagnosis: 'ДЦП, спастическая диплегия. Структурная эпилепсия',
    helpText:
      'Проект «PRO-катит», помощь в разработке ИПРА.<br/> Совместно с экспертами фонда ведется активная работа над увеличением суммы&nbsp;электронных сертификатов на приобретение технических средств реабилитации (ТСР).',
    quoteText:
      '«Хочу выразить огромную благодарность сотрудникам фонда и всем, кто участвовал в помощи разработки ИПРА для моего сына. Это очень помогло нам в решении проблем с электронными сертификатами. Сейчас на основании хорошо разработанной ИПРА ведётся работа с ФСС по получению ЭС на опору для стояния и колясок. Для наших деток очень важно правильно подобранное ТСР, ведь от этого зависит состояние здоровья ребёнка.<br/> Низкий Вам материнский поклон».'
  },
  {
    id: 4,
    name: 'Никита',
    image: `${CDN}/avatar-nikita_new.png`,
    photo: `${CDN}/nikita_new.png`,
    fullName: 'Никита',
    age: '18 лет',
    diagnosis: '',
    helpText:
      'Проект «PRO-катит», велотренажер (велосипед). Пожертвование велотренажера механического универсального.',
    quoteText:
      '«От всего сердца благодарю за помощь Никите. Ребёнку очень нужен был лечебный велосипед. В связи с частым эпи. приступами у Никиты приходят в&nbsp;спазм&nbsp;мышцы, порой он даже не может идти при поддержке. Реабилитацию также не можем проходить по финансовым трудностями. Велосипед, разработанный специально для особенного ребёнка, наша единственная помощь ребёнку, тем более у Никиты ранее был велосипед, с которого он давно вырос. Спасибо за помощь в приобретении. Всем здоровья и всего самого доброго».'
  },
  {
    id: 6,
    name: 'Лев',
    image: `${CDN}/avatar-lev2_new.png`,
    photo: `${CDN}/lev-new.png`,
    fullName: 'Лев',
    age: '5 лет',
    diagnosis: '',
    helpText:
      'Проект «Под крылом», долгосрочная социальная абилитация. Оплата реабилитационных услуг (долгосрочная социальная абилитация) в партнёрском центре фонда.',
    quoteText:
      '«Выражаю огромную благодарность Благотворительному Фонду «ГАЛЧОНОК» за возможность регулярно реабилитировать сына. У Льва произошел обширный инсульт в младенчестве в результате чего был выставлен диагноз ДЦП и синдром Веста, сыну необходима постоянная реабилитация, потому что пострадали все сферы: и двигательная, и интеллектуальная, и речевая, так сложилось, что мы с супругом развелись и мне приходится воспитывать сына одной, для нас это уникальная возможность получать занятия и шанс для сына адаптироваться в обществе. Финансово я не смогла бы потянуть столько занятий. Очень рады и благодарны, что попали в эту программу, Лиля и Лев».'
  }
];

export function Wards({ className }: { className?: string }) {
  const [activeTab, setActiveTab] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const slots = styles({ isExpanded });
  const currentTab = tabs[activeTab] ?? tabs[0];

  useEffect(() => {
    setIsExpanded(false);
  }, [activeTab]);
  const isPrevDisabled = activeTab === 0;
  const isNextDisabled = activeTab >= tabs.length - 1;

  const handlePrev = () => {
    if (isPrevDisabled) return;
    setActiveTab(activeTab - 1);
  };

  const handleNext = () => {
    if (isNextDisabled) return;
    setActiveTab(activeTab + 1);
  };

  const handleReadMore = () => {
    if (isExpanded) {
      setIsExpanded(false);
      requestAnimationFrame(() => {
        contentRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
      return;
    }

    setIsExpanded(true);
  };

  return (
    <div
      className={slots.base({ className })}
      id="history"
    >
      <div className={slots.info()}>
        <h3 className={slots.title()}>Подопечные фонда</h3>
        <div className={slots.imageWrapper()}>
          <div className={slots.arrows()}>
            <button
              type="button"
              className={slots.arrowPrev()}
              onClick={handlePrev}
              disabled={isPrevDisabled}
              aria-label="Предыдущий подопечный"
            >
              <ArrowIcon
                className="size-6 rotate-180"
                aria-hidden
              />
            </button>
            <button
              type="button"
              className={slots.arrowNext()}
              onClick={handleNext}
              disabled={isNextDisabled}
              aria-label="Следующий подопечный"
            >
              <ArrowIcon
                className="size-6"
                aria-hidden
              />
            </button>
          </div>
          <div className={slots.image()}>
            {currentTab.photo ? (
              <Image
                className="w-full"
                src={currentTab.photo}
                alt={currentTab.name}
                width={482}
                height={680}
              />
            ) : (
              <div
                className="aspect-[482/680] w-full bg-[#E8EDF5]"
                aria-hidden
              />
            )}
          </div>
        </div>
      </div>
      <div
        ref={contentRef}
        className={slots.content()}
      >
        <div className={slots.tabs()}>
          {tabs.map((tab, index) => (
            <button
              key={tab.id}
              type="button"
              className={slots.tab()}
              aria-pressed={index === activeTab}
              onClick={() => setActiveTab(index)}
            >
              <div
                className={slots.tabImage({ isActive: index === activeTab })}
              >
                <Image
                  src={tab.image}
                  alt={tab.name}
                  width={51}
                  height={51}
                />
              </div>
              <p className={slots.tabName({ isActive: index === activeTab })}>
                {tab.name}
              </p>
            </button>
          ))}
        </div>
        <p className={slots.name()}>
          {currentTab.fullName}{' '}
          <span className={slots.age()}>· {currentTab.age}</span>
        </p>
        <p className={slots.diagnosis()}>{currentTab.diagnosis}</p>
        <div className={slots.blocks()}>
          <div className={slots.block()}>
            <p className={slots.blockTitle()}>Какая помощь оказана</p>
            <p
              className={slots.blockText()}
              dangerouslySetInnerHTML={{ __html: currentTab.helpText }}
            />
          </div>
          <div className={slots.blockLast()}>
            <p className={slots.blockTitle()}>Слова от мамы</p>
            <p
              className={slots.blockText()}
              dangerouslySetInnerHTML={{ __html: currentTab.quoteText }}
            />
          </div>
        </div>
        <button
          type="button"
          className={slots.readMore()}
          onClick={handleReadMore}
        >
          {isExpanded ? 'скрыть' : 'читать все'}
          <ChevronIcon
            className={slots.readMoreIcon()}
            aria-hidden
          />
        </button>
      </div>
    </div>
  );
}
